import React, { useState, useEffect } from 'react';
import ParticlesCanvas from './components/ParticlesCanvas/ParticlesCanvas';
import BackgroundGradients from './components/BackgroundGradients/BackgroundGradients';
import Navigation from './components/Navigation/Navigation';
import Hero from './components/Hero/Hero';
import ProctorShowcase from './components/ProctorShowcase/ProctorShowcase';
import Features from './components/Features/Features';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Modules from './components/Modules/Modules';
import SuccessShowcase from './components/SuccessShowcase/SuccessShowcase';
import VideoSection from './components/VideoSection/VideoSection';
import Stats from './components/Stats/Stats';
import CTA from './components/CTA/CTA';
import ProctorLogos from './components/ProctorLogos/ProctorLogos';
import Footer from './components/Footer/Footer';
import PromoBadge from './components/PromoBadge/PromoBadge';
import './App.css';

// Промо-акция: 'hero' — наклейка в Hero | 'popup' — фикс. поп-ап снизу слева | 'none' — выкл.
const PROMO_VARIANT = 'hero';
// Вид баннера на мобильных: 'star' | 'coin' | 'fire' | 'ribbon'
const PROMO_SKIN = 'star';

function App() {
  const [isAtBottom, setIsAtBottom] = useState(false);

  const sections = [
    '.hero',
    '.proctor-showcase',
    '.features',
    '.how-it-works',
    '.module-2-section',
    '.module-3-section',
    '.success-showcase',
    '.video-section',
    '.stats-section',
    '.cta-section',
    '.proctor-logos-section'
  ];

  // Проверяем, достигли ли секции proctor-logos
  useEffect(() => {
    const handleScroll = () => {
      const logosSection = document.querySelector('.proctor-logos-section');
      if (logosSection) {
        const logosSectionTop = logosSection.offsetTop;
        const scrollPosition = window.pageYOffset + window.innerHeight / 2;
        setIsAtBottom(scrollPosition >= logosSectionTop);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToNextSection = () => {
    // Если внизу - скроллим наверх
    if (isAtBottom) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    // Иначе скроллим к следующей секции
    const navbarHeight = 80;
    const currentScrollPosition = window.pageYOffset;
    
    let currentSectionIndex = 0;
    
    for (let i = 0; i < sections.length; i++) {
      const section = document.querySelector(sections[i]);
      if (section) {
        const sectionTop = section.offsetTop - navbarHeight;
        
        if (currentScrollPosition >= sectionTop - 100) {
          currentSectionIndex = i;
        } else {
          break;
        }
      }
    }
    
    const nextIndex = currentSectionIndex + 1;
    if (nextIndex < sections.length) {
      const nextSection = document.querySelector(sections[nextIndex]);
      if (nextSection) {
        const elementPosition = nextSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div className="App">
      <ParticlesCanvas />
      <BackgroundGradients />
      <Navigation />
      <Hero showPromo={PROMO_VARIANT === 'hero'} promoSkin={PROMO_SKIN} />
      <ProctorShowcase />
      <Features />
      <HowItWorks />
      <Modules />
      <SuccessShowcase />
      <VideoSection />
      <Stats />
      <CTA />
      <ProctorLogos />
      <Footer />

      {PROMO_VARIANT === 'popup' && <PromoBadge variant="fixed" skin={PROMO_SKIN} />}
      
      {/* Scroll Indicator - меняется на стрелку вверх внизу */}
      <div 
        className={`scroll-indicator ${isAtBottom ? 'scroll-up' : ''}`}
        onClick={scrollToNextSection}
      >
        {isAtBottom ? (
          // Стрелка вверх
          <div className="scroll-arrow-up">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path 
                d="M16 24V8M16 8L9 15M16 8L23 15" 
                stroke="#FDB241" 
                strokeWidth="3" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ) : (
          // Обычный scroll mouse
          <div className="scroll-mouse">
            <div className="scroll-wheel"></div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
